import { AvatarB2B, AvatarB2C, S7, S7Circle, S7Profi, S7ProfiCircle, S7Shop } from "../icons";
export var themes = {
  b2c: 'b2c',
  b2b: 'b2b',
  shop: 'shop'
};
export var LOGOS = {
  b2c: S7,
  b2b: S7Profi,
  shop: S7Shop
};
export var MOBILE_LOGOS = {
  b2c: S7Circle,
  b2b: S7ProfiCircle,
  shop: S7Shop
};
export var AVATARS = {
  b2c: AvatarB2C,
  b2b: AvatarB2B
};
export var CURRENCY_STYLE = {
  fontWeight: '600'
};
export var pointTypesEnum = {
  link: 'Link',
  button: 'Button',
  text: 'Text'
};
export var pointTypes = Object.values(pointTypesEnum);